export default "__VITE_ASSET__DcJstP7a__"